const ComponentDefaults = {
  className: "",
  style: {}
};
export {
  ComponentDefaults as C
};
